import { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { colors } from "@zapalacorp/tokens";

const DEFAULT_BORDER = "1px solid #F2F4F7 !important";
const DEFAULT_NONE = "none !important";
const DEFAULT_BOX_SHADOW_RIGHT = "0px -1px 0px #CCDEEE inset";

const HEADER_HEIGHT = "38px";

const styles = makeStyles<Theme, { disablePadding?: boolean }>(() => ({
  calendar: {
    padding: ({ disablePadding }) => (disablePadding ? undefined : "24px"),
    "& .rbc-header": {
      background: "#FCFCFD !important",
      height: HEADER_HEIGHT,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      borderLeft: "none",
      borderBottom: "none",
      boxShadow: DEFAULT_BOX_SHADOW_RIGHT,
      "&:first-child": {
        borderTopLeftRadius: "8px",
      },
      "&:last-child": {
        borderTopRightRadius: "8px",
      },
      "& span": {
        fontFamily: "Manrope",
        color: "#667085",
        fontWeight: 800,
        fontSize: "12px",
      },
    },
    "& .rbc-today": {
      background: "#FFFFFF !important",
    },
    "& .rbc-time-content": {
      borderTop: DEFAULT_NONE,
    },
    "& .rbc-label": {
      color: "#465869",
      fontFamily: "Manrope",
      fontWeight: 400,
      fontSize: "13px",
    },
    "& .rbc-show-more": {
      backgroundColor: "#EDF5FB",
      height: "28px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      color: "#3F6280",
      fontFamily: "Inter",
      fontWeight: 600,
      fontSize: "12px",
      marginLeft: "8px",
      lineHeigth: "20px",
      padding: "2px 8px",
      borderRadius: "12px",
      "&:hover": {
        backgroundColor: "#F6FBFF",
      },
    },
  },

  month: {
    "& .rbc-month-row + .rbc-month-row": {
      borderTop: DEFAULT_BORDER,
    },
    "& .rbc-day-bg": {
      borderLeft: DEFAULT_BORDER,
    },
    "& .rbc-off-range-bg": {
      background: "#FCFCFD !important",
    },
    "& .rbc-month-view, .rbc-time-view, ": {
      borderRadius: "8px !important",
    },
  },

  week: {
    "& .rbc-time-view": {
      border: "none !important",
    },
    "& .rbc-allday-cell": {
      display: "none",
    },
    // NTH-CHILD 2 is the first rbc-day
    "& .rbc-day-slot:nth-child(2) .rbc-events-container": {
      borderLeft: `1px solid ${colors.brandBlue50} !important`,
    },
    "& .rbc-time-gutter": {
      paddingLeft: "16px",
      paddingRight: "16px",
    },
    "& .rbc-time-header-content": {
      borderTopLeftRadius: "12px",
      borderTopRightRadius: "12px",
      borderTop: `1px solid ${colors.brandBlue50} !important`,
      borderLeft: `1px solid ${colors.brandBlue50} !important`,
      borderRight: `1px solid ${colors.brandBlue50} !important`,
      boxShadow: "none",
    },
    "& .rbc-header": {
      "&:not(:last-child)": {
        borderRight: `1px solid ${colors.brandBlue50} !important`,
      },
      "&:first-child": {
        borderTopLeftRadius: "12px !important",
      },
      "&:last-child": {
        borderTopRightRadius: "12px !important",
      },
    },
    "& .rbc-time-slot": {
      border: DEFAULT_NONE,
      display: "flex",
      alignItems: "center",
    },
    "& .rbc-timeslot-group": {
      borderBottom: DEFAULT_NONE,
      minHeight: "56px",
    },
    "& .rbc-time-column:nth-child(even)": {
      backgroundColor: "#F9FAFB !important",
    },
    "& .rbc-current-time-indicator": {
      display: DEFAULT_NONE,
    },
    "& .rbc-time-content > * + * > *": {
      border: "inherit",
    },
    "& .rbc-events-container": {
      margin: "0px !important",
      borderRight: `1px solid ${colors.brandBlue50} !important`,
      borderBottom: `1px solid ${colors.brandBlue50} !important`,
    },
  },

  day: {
    "& .rbc-current-time-indicator": {
      display: "none",
    },
    "& .rbc-allday-cell": {
      display: "none",
    },
    "& .rbc-time-slot": {
      border: DEFAULT_NONE,
    },
    "& .rbc-timeslot-group": {
      minHeight: "80px",
    },
    "& .rbc-time-content > * + * > *": {
      borderLeft: DEFAULT_NONE,
    },
    "& .rbc-time-column:nth-child(even)": {
      backgroundColor: "#FFFFFF !important",
    },
    "& .rbc-time-header-gutter": {
      display: DEFAULT_NONE,
    },
  },

  topbar: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    marginBottom: "24px",
  },

  information: {
    color: "#465869",
    fontFamily: "Inter",
    fontWeight: 600,
    fontSize: "18px",
    marginLeft: "16px",
  },

  arrow: {
    width: "28px",
    height: "28px",
    backgroundColor: "rgb(237, 245, 251)",
    borderRadius: "50%",
    marginRight: "12px",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    "&:hover": {
      backgroundColor: "rgba(237, 245, 251, .5)",
    },
  },

  gmtContainer: {
    height: HEADER_HEIGHT,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  gmtLabel: {
    color: "#667085",
    fontFamily: "Manrope",
    fontSize: "12px",
    fontWeight: 800,
  },

  skeleton: {
    minHeight: "80vh",
  },

  mt_16: {
    marginTop: "-16px",
  },

  dateLabel: {
    display: "flex",
    paddingTop: "16px",
    paddingLeft: "16px",
    paddingRight: "16px",
    marginBottom: "8px",

    fontFamily: "Manrope",
    fontSize: "16px",
    fontStyle: "normal",
    lineHeight: "normal",
    color: colors.gray400,
  },
}));

export default styles;
